import React, { Component } from 'react';
import { createSelector } from "reselect";
import { connect } from "react-redux";
import { Main } from '../../layout';
import { DocumentTitle } from '../../../helpers';
import SimpleReactValidator from 'simple-react-validator';
import { defaultActions } from '../../../common/redux/actions';

class ContactUs extends Component {

    constructor(props) {
        super(props);

        this.state = {
            formField: {
                first_name: '',
                last_name: '',
                email: '',
                mobile: '',
                subject: '',
                body: '',
            },
            value: "",
            expired: "false"
        };
        this.initializeState = this.state;
        this.validator = new SimpleReactValidator({
            autoForceUpdate: this,
            className: 'valid-feedback d-block text-danger',
        });
    }

    handleChange = (e) => {
        let formField = { ...this.state.formField };
        formField[e.target.name] = e.target.value;
        this.setState({ formField });
    };

    handleSubmit = (e) => {
        e.preventDefault();
        const { formField } = this.state;
        if( this.validator.allValid() ) {
            const { dispatch } = this.props;
            dispatch(defaultActions.contact({ contactForm: formField }));
            this.setState(this.initializeState);
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    };


    render() {
        this.validator.purgeFields();
        const { formField } = this.state;
        const { process } = this.props;
        return (<Main>
            <DocumentTitle title={`Contact Us`} />

            <section className="login-page contact-us my-5 py-5" style={{backgroundImage: `url(/images/demo.png)`}}>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-4 col-md-5 col-sm-6 col-12">
                            <div className="login-box">
                                <h1 className="text-left mb-4">Let's Connect</h1>
                                <form onSubmit={this.handleSubmit}>
                                    
                                    <div className="form-group mb-4">
                                        <label>First Name<span className="text-danger">*</span></label>
                                        <input type="text" className="form-control" placeholder="Name" name="first_name" value={formField.first_name} onChange={this.handleChange} />
                                        {this.validator.message('first_name', formField.first_name, 'required')}
                                    </div>
                                    <div className="form-group mb-4">
                                        <label>Last Name<span className="text-danger">*</span></label>
                                        <input type="text" className="form-control" placeholder="Name" name="last_name" value={formField.last_name} onChange={this.handleChange} />
                                        {this.validator.message('last_name', formField.last_name, 'required')}
                                    </div>
                                    <div className="form-group">
                                        <label>Subject<span className="text-danger">*</span></label>
                                        <input type="text" className="form-control" placeholder="Subject" name="subject" value={formField.subject} onChange={this.handleChange} />
                                        {this.validator.message('subject', formField.subject, 'required')}
                                    </div>
                                    <div className="form-group mb-4">
                                        <label>Email<span className="text-danger">*</span></label>
                                        <input type="email" className="form-control" placeholder="Email Address" name="email" value={formField.email} onChange={this.handleChange} />
                                        {this.validator.message('email', formField.email, 'required|email')}
                                    </div>
                                    <div className="form-group mb-4">
                                        <label>Contact Number<span className="text-danger">*</span></label>
                                        <input type="text" className="form-control" placeholder="Phone Number" name="mobile" value={formField.mobile} onChange={this.handleChange} />
                                        {this.validator.message('mobile', formField.mobile, 'required')}
                                    </div> 
                                    {/*<div className="form-group">
                                        <label>Contact Number<span className="text-danger">*</span></label>
                                        <input type="text" className="form-control" placeholder="Mobile" name="mobile" value={mobile} onChange={this.handleChange} />
                                        {this.validator.message('mobile', mobile, 'required')}
                                    </div>
                                    <div className="form-group">
                                        <input type="text" className="form-control" placeholder="Subject" name="subject" value={formField.subject} onChange={this.handleChange} />
                                        {this.validator.message('subject', formField.subject, 'required')}
                                    </div>*/}
                                    <div className="form-group mb-4">
                                        <label>Message<span className="text-danger">*</span></label>
                                        <textarea className="form-control" rows="4" placeholder="Message" name="body" onChange={this.handleChange}
                                            value={formField.body}></textarea>
                                            {this.validator.message('body', formField.body, 'required')}
                                    </div>
                                    <div className="form-group">
                                        <button type="submit" className="btn btn-primary w-100">Submit 
                                            {process.leading && <span className="spinner-border spinner-border-sm"></span>}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                        {/* <div className="col-lg-8 col-md-7 col-sm-6 col-12">
                            <div className="image mt-5 pt-lg-5">
                                <img className="img-fluid" src="/images/contacts.png" alt="Banner" />
                            </div>
                        </div> */}
                    </div>	
                </div>
            </section>

        </Main>);
    }
}


const processSelector = createSelector(
    state => state.process,
    process => process
);

const mapStateToProps = createSelector(
    processSelector,
    (process) => ({
        process
    })
);

export default connect(mapStateToProps)(ContactUs);